export const RESPONSE = {
  STATUSTEXT: "OK",
  STATUS_SUCCESS: 200,
  STATUS_UNAUTHORIZED: 401,
};

export const SIZE_PER_PAGE_LIST = [15, 20, 50, 100];
export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_PAGE_SIZE_10 = 10;

export const ROLE = {
  ICT_ROLE: 1,
  HR_ROLE: 2,
  DIRECTOR: 3,
  HEAD_OF_FACTORY: 4,
  MANAGER_ROLE: 5,
  SUB_MANAGER_ROLE: 6,
  LEADER_ROLE: 7,
  SUB_LEADER_ROLE: 8,
  EMPLOYEE_ROLE: 9,
};

export const GENDER = {
  // UNKNOWN: 0,
  MALE: 1,
  FEMALE: 2,
};

export const WORK_STATUS = {
  STATUS_WORK01: 1, // Đang làm việc
  STATUS_WORK02: 2, // Thử việc
  STATUS_WORK03: 3, // Tạm nghỉ
  STATUS_WORK04: 4, // Nghỉ thai sản
  STATUS_WORK05: 5, // Đã nghỉ việc
  STATUS_WORK06: 6, // Khác
};

export const EDUCATION_LEVEL = {
  EDU01: 1,
  EDU02: 2,
  EDU03: 3,
  EDU04: 4,
  EDU05: 5,
  EDU06: 6,
  EDU07: 7,
  EDU08: 8,
  EDU09: 9,
  EDU10: 10,
  EDU00: 0,
};

export const MARITAL_STATUS = {
  SINGLE: 1,
  MARRIED: 2,
};

export const INSURANCE_STATUS = {
  JOIN: 1,
  NOT_JOIN: 0,
};

export const TAX_TYPE = {
  EXEMPTION: 1,
  PROGRESSIVE: 2,
  TEN_PERCENT: 3,
  TWENTY_PERCENT: 4,
};

export const CALCULATION_METHOD = {
  DAY: 1,
  MONTH: 2,
};

export const HOLIDAY_TYPE = {
  NATIONAL_HOLIDAY: 1,
  COMPANY_HOLIDAY: 2,
  OTHER_HOLIDAY: 3,
};

export const OVERTIME_TYPE = {
  NORMAL: 1,
  REST: 2,
  HOLIDAY: 3,
  NIGHT_NORMAL: 4,
  NIGHT_REST: 5,
  NIGHT_HOLIDAY: 6,
  NIGHT: 7,
};

export const APPLY_BY_FORMULA = {
  DAY: 1,
  TIME: 2,
  PERIOD: 3,
};

export const APPLICATION_METHOD = {
  FIXED_AMOUNT: 1,
  FORMULA: 2,
  FLEXIBLE_AMOUNT: 3,
};

export const TAX_CALCULATION = {
  TAXABLE: 1,
  PARTIALLY_TAXABLE: 2,
  TAX_EXEMPT: 3,
};

export const SCOPE_OF_APPLICATION = {
  NO_AUTO_APPLY: 1,
  ENTIRE_COMPANY: 2,
  SPECIFIC_CONDITIONS: 3,
};

export const DECOMMISSIONED_DEDUCTION_CODES = [
  "SI",
  "HI",
  "UI",
  "UNION",
  "SOCIAL_INSURANCE",
  "HEALTH_INSURANCE",
  "UNEMPLOY_INS",
  "UNION_FEE",
  "PIT",
  "ADVANCE",
  "ADVANCE_PAYMENT",
  "LATE_DEDUCTION",
  "ABSENCE_DEDUCTION",
];

export const DEDUCT_LEAVE_OPTIONS = {
  NO: 0,
  BASIC: 1,
  SPECIAL: 2,
};

export const DEDUCT_ATTENDANCE_OPTIONS = {
  YES: 1,
  NO: 0,
};

export const LATE_EARLY_TYPE = {
  LATE: 1,
  RETURN_LATE: 2,
  EARLY: 3,
};
